export default function (d, w, id) {
    return new Promise((resolve, reject) => {
      if (d.getElementById(id)) return;
  
      const ts = d.createElement("script");
      ts.type = "text/javascript";
      ts.async = true;
      ts.id = id;
      ts.src = `https://top-fwz1.mail.ru/js/code.js`
  
      ts.addEventListener('load', () => {
        resolve(window.carrotquest)
      })
      ts.addEventListener('error', () => {
        reject(new Error(`Failed to load script`))
      })
  
      const f = function() {
        const s = d.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(ts, s);
      };
  
      // Создаем  элемент для метрики
      const noscript = document.createElement('noscript');
      const div = document.createElement('div');
      const img = document.createElement('img');
  
      img.setAttribute('src', 'https://top-fwz1.mail.ru/counter?id=3249858;js=na');
      img.setAttribute('style', 'position:absolute;left:-9999px;');
      img.setAttribute('alt', 'Top.Mail.Ru');
  
      div.appendChild(img);
  
      noscript.appendChild(div);
  
      const addMailCounter = function() {
        document.body.appendChild(noscript);
      }
  
  
  
      if (w.opera === "[object Opera]") {
        d.addEventListener("DOMContentLoaded", f, false);
        d.addEventListener("DOMContentLoaded",addMailCounter, false )
      } else {
        f();
        addMailCounter();
      }
    })
  }
  